import { render, staticRenderFns } from "./DefaultPasswordEditComplete.vue?vue&type=template&id=9a94255c&lang=pug&"
import script from "./DefaultPasswordEditComplete.vue?vue&type=script&lang=ts&"
export * from "./DefaultPasswordEditComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports